"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Форматирование времени на доставку для отображения в интерфейсах
 * @param timeInMinutes - время на доставку в минутах
 */
function formatDeliveryTime(timeInMinutes) {
    if (!timeInMinutes) {
        return undefined;
    }
    else {
        if (timeInMinutes <= 90) {
            return timeInMinutes + ' мин';
        }
        else {
            var hours = Math.trunc(timeInMinutes / 60);
            var minutes = timeInMinutes - hours * 60;
            if (hours && minutes) {
                return hours + " \u0447 " + minutes + " \u043C\u0438\u043D";
            }
            if (hours) {
                return hours + " \u0447";
            }
        }
    }
}
exports.formatDeliveryTime = formatDeliveryTime;
//# sourceMappingURL=index.js.map